(function()
{
	//Library depencencies
	var Application = include('springroll.Application');
	var Debug = include('springroll.Debug', false);
	var DebugOptions = include('nature.DebugOptions');
	var DelayedCall = include('springroll.DelayedCall');
	var Display = include('springroll.pixi.PixiDisplay');
	var GameState = include('nature.GameState');
	var TitleState = include('nature.TitleState');

	//Set up this to use texture filenames
	PIXI.utils.useFilenamesForTextures = true;

	//Create a new application
	var app = new Application(
	{
		name: "seed-soaring",
		canvasId: "stage",
		useQueryString: DEBUG,
		configPath: "assets/config/config.json",
		captionsPath: "assets/config/captions.json",
		state: 'title',
		display: Display,
		displayOptions:
		{
			clearView: true,
			transparent: true
		},
		transitionSounds:
		{
			out: "TransitionStart",
			loop: "TransitionMiddle",
			in : "TransitionEnd"
		}
	});

	app.once('configLoaded', function(config, assets)
	{
		//Add the initial preload assets
		config.assets.init.forEach(function(asset)
		{
			assets.push(asset);
		});
	});

	//Handle when app is ready to use
	app.once('init', function()
	{
		DebugOptions.init();

		DelayedCall.calls = [];
		app.pauseCalls = function(pause)
		{
			var calls = DelayedCall.calls;
			for (var i = calls.length - 1; i >= 0; --i)
			{
				var dc = calls[i];
				dc.paused = pause;
				if (!dc._timer || dc._timer < 0)
				{
					dc.destroy();
					calls.splice(i, 1);
				}
			}
		};

		DelayedCall.destroyCalls = function()
		{
			var calls = DelayedCall.calls;
			for (var i = calls.length - 1; i >= 0; --i)
			{
				var dc = calls[i];
				if (dc)
				{
					dc.destroy();
				}
			}
			DelayedCall.calls = [];
		};

		if (DebugOptions.skipIntro)
		{
			this.skipIntro = true;
		}

		/**
		 * Has the badge for 500ft reached been sent
		 * @property {Boolean} fiveHundredFeetCheck
		 */
		this.fiveHundredFeetCheck = false;

		/**
		 * Should we show (or is currently showing) the tutorial
		 * @property {Boolean} isTutorial
		 */
		this.isTutorial = true;

		/**
		 * The pooled floaters by type
		 * @property {Object} _app.floaterPools
		 */
		this.floaterPools = {};

		/**
		 * Has the user lost all their seeds?
		 * @property {Boolean} isGameOver
		 */
		this.isGameOver = false;

		this.userData.read(this.config.params.highScoreCookie, function(data)
		{
			app._userHighScore = data || 0;
		});

		// Add the transition
		this.transition = new pixiflash_lib.Transition();
		this.transition.framerate = 30;

		// Start application
		var assets = this.config.assets;
		var scaling = this.config.scaling;

		//Set the states to use
		this.states = {
			title: new TitleState(
			{
				next: 'game',
				scaling: scaling.title,
				preload: assets.title
			}),
			game: new GameState(
			{
				delayLoad: 10,
				next: 'title',
				previous: 'title',
				scaling: scaling.game,
				preload: [].concat(
					assets.game.backgrounds,
					assets.game.sounds,
					assets.game.characters,
					assets.game.ui)
			})
		};

		this.manager.waitForLoadingComplete = true;

		if (DebugOptions.volume)
		{
			if (DebugOptions.volume === true) DebugOptions.volume = 0.1;
			this.music = null;
			this.sound.setContextVolume('vo', DebugOptions.volume);
			this.sound.setContextVolume('sfx', DebugOptions.volume);
		}
		else if (DebugOptions.muteMusic)
		{
			this.music = null;
		}
		else
		{
			if (this.sound.systemMuted)
			{
				this.sound.on("systemUnmuted", function()
				{
					this.music = "SeedSoaring_Loop_v03";
				}.bind(this));
			}
			else
			{
				this.music = "SeedSoaring_Loop_v03";
			}
		}

	});

	/**
	 * user's cached highest score for user
	 * @property {Boolean} userHighScore
	 */
	Object.defineProperty(app, 'userHighScore',
	{
		get: function()
		{
			return app._userHighScore;
		},
		set: function(score)
		{
			app.userData.write(app.config.params.highScoreCookie, score);
			app._userHighScore = score;
		}
	});

	// Assign to the window for easy access
	window.app = app;

  // SpringRoll supposedly uses an old version of createjs.Sound methods (pause and resume), which is mentioned in
  // this related ticket: https://github.com/SpringRoll/SpringRoll/issues/154
  // However, we're pulling in the SpringRoll forks so I'm not sure why I need to do this. But doing this allows the
  // springroll Sound pause method to work properly and not throw an error during the tutorial loop (mentioned in this
  // ticket: https://www.pivotaltracker.com/story/show/161817769).
  createjs.WebAudioSoundInstance.prototype.pause = function() { this.paused = true; };
  createjs.WebAudioSoundInstance.prototype.resume = function() { this.paused = false; };
}());
